exports.ById = {
  1: { Id: 1, Name: 'pli_value_type.gross_margin', Value: { displayFormat: 0, roundingValue: 2 } },
  2: { Id: 2, Name: 'pli_value_type.berry_ratio', Value: { displayFormat: 1, roundingValue: 4 } },
  3: { Id: 3, Name: 'pli_value_type.operating_margin', Value: { displayFormat: 0, roundingValue: 2 } },
  4: { Id: 4, Name: 'pli_value_type.return_on_operating_assets', Value: { displayFormat: 0, roundingValue: 2 } },
  5: { Id: 5, Name: 'pli_value_type.cost_plus', Value: { displayFormat: 0, roundingValue: 2 } },
  6: { Id: 6, Name: 'pli_value_type.net_cost_plus', Value: { displayFormat: 0, roundingValue: 2 } },
};

exports.ByName = {
  'pli_value_type.gross_margin': { Id: 1, Name: 'pli_value_type.gross_margin', Value: { displayFormat: 0, roundingValue: 2 } },
  'pli_value_type.berry_ratio': { Id: 2, Name: 'pli_value_type.berry_ratio', Value: { displayFormat: 1, roundingValue: 4 } },
  'pli_value_type.operating_margin': { Id: 3, Name: 'pli_value_type.operating_margin', Value: { displayFormat: 0, roundingValue: 2 } },
  'pli_value_type.return_on_operating_assets': { Id: 4, Name: 'pli_value_type.return_on_operating_assets', Value: { displayFormat: 0, roundingValue: 2 } },
  'pli_value_type.cost_plus': { Id: 5, Name: 'pli_value_type.cost_plus', Value: { displayFormat: 0, roundingValue: 2 } },
  'pli_value_type.net_cost_plus': { Id: 6, Name: 'pli_value_type.net_cost_plus', Value: { displayFormat: 0, roundingValue: 2 } }

};
